import React, { useEffect, useState } from "react";
import GlobalLoader from "../shared/GlobalLoader";
import { useNavigate } from "react-router-dom";
import { useLoading } from "../../context/LoadingContext";
import useGetData from "../Custom-Hooks/useGetData";
import axios from "axios";
import SuccessPopup from "../shared/SuccessPopup";
import { useDashboard } from "../../context/DashboardContext";

const UserPreference = () => {
    const navigate = useNavigate();
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const accessToken = sessionStorage.getItem("accessToken");
    const userDetails = JSON.parse(localStorage.getItem("userDetails") || "");
    const [formData, setFormData] = useState({
        pageTitle: "",
        isDefault: false,
        status: true
    });
    const headers = accessToken
        ? {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
        }
        : { "Content-Type": "application/json" };
    const [errors, setErrors] = useState({});
    const [modalState, setModalState] = useState({ isOpen: false, type: '' });
    const [showSuccessPopup, setShowSuccessPopup] = useState({
        type: "",
        show: false,
        message: ""
    });
    const { dashboardData, setShouldRefetch } = useDashboard();
    const requiredFields = modalState?.type === "new"
        ? ["pageTitle"]
        : ["pageTitle"];

    const { isLoading, setLoading } = useLoading();
    const { data: allowedWidgetsData, isLoading: getLoading } = useGetData(`${baseUrl}/user/${userDetails?.id}/allowedWidgets`);

    useEffect(() => {
        if (dashboardData.length === 0) {
            setShouldRefetch(true); // Trigger refetch if there are no pages loaded initially
        }
    }, [dashboardData, setShouldRefetch]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        if (requiredFields.includes(name)) {
            setErrors((prev) => ({
                ...prev,
                [name]: value.trim() === "" ? "This field is required" : "",
            }));
        }
    };

    const handleBlur = (e) => {
        const { name, value } = e.target;

        if (requiredFields.includes(name)) {
            setErrors((prev) => ({
                ...prev,
                [name]: value.trim() === "" ? "This field is required" : "",
            }));
        }
    };

    const handleNewPage = () => {
        setModalState({ isOpen: true, type: 'new' });
    };

    const handleUpdatePage = async (page) => {
        setFormData(page);
        setModalState({ isOpen: true, type: 'update' });
    };


    const handleFormSave = async () => {
        const newErrors = {};

        requiredFields.forEach((field) => {
            if (formData[field].trim() === "") {
                newErrors[field] = "This field is required";
            }
        });

        if (formData?.isDefault === true && formData?.status === false) {
            newErrors["status"] = "Default screen can't be inactive";
        }

        setErrors(newErrors);

        if (Object.keys(newErrors).length === 0) {

            const payload = {
                pageTitle: formData?.pageTitle || "",
                isDefault: formData?.isDefault,
                widgets: [],
                status: formData?.status,
                userId: userDetails?.id,
                ...(formData.pageId && { pageId: formData.pageId })
            }

            const url = formData.pageId
                ? `${baseUrl}/user/${userDetails?.id}/updateDashboardPage`
                : `${baseUrl}/user/${userDetails?.id}/createDashboardPage`;

            const method = formData.pageId ? "put" : "post";

            const response = await axios[method](`${url}`, JSON.stringify(payload), { headers });

            if (response.data.success) {
                setShouldRefetch(true);
                setShowSuccessPopup({
                    type: "success",
                    show: true,
                    message: response?.data?.message,
                });
            } else {
                setShowSuccessPopup({
                    type: "warning",
                    show: true,
                    message: response?.data?.message,
                });
            }

            handleCloseModal(); // Optionally close the modal
        }
    };

    const handleCloseModal = () => {
        setModalState({ isOpen: false, type: '' });
        setFormData({
            pageTitle: "",
            isDefault: false,
            status: true
        });
        setErrors({});
    };

    const setUserPreferenceWidgets = (page) => {
        navigate('user-preference-widgets', { state: { pageId: page.pageId, pageTitle: page.pageTitle } });
    };


    return (
        <div className="container-fluid">
            {isLoading && <GlobalLoader />}
            <div className="row theme-container rounded custom-shadow mx-2">
                <div className="col-6">
                    <div className="py-3 px-2 fnt14 fw-600 d-flex justify-content-start" draggable="true">
                        User Preferences
                    </div>
                </div>

                <div className="col-6 d-flex align-items-center justify-content-end">
                    <button type="submit" className="btn btn-primary d-flex justify-content-center align-items-center"
                        onClick={() => handleNewPage('new')}>
                        Add New Page
                    </button>
                </div>

                <div className="col-12">
                    <div className="py-3 px-2 fnt14 fw-600 d-flex justify-content-start">
                        Dashboard Pages
                    </div>
                </div>

                <div className="col-8 mb-2">
                    <table className="user-management-table">
                        <thead>
                            <tr className="user-management-table-tr" style={{ backgroundColor: '#001744', color: 'white' }}>
                                <th>Page Name</th>
                                <th>Page Order</th>
                                <th>Default</th>
                                <th>Widgets</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* Dynamic rows from API */}
                            {dashboardData?.map((page, index) => (
                                <tr key={page.pageId} style={{ textAlign: 'center' }}>
                                    <td>{page.pageTitle}</td>
                                    <td>{index + 1}</td>
                                    <td>{page.isDefault ? 'Yes' : 'No'}</td>
                                    <td>{allowedWidgetsData?.initialDashboardAllowedWidgets?.length || 0}</td>
                                    <td>
                                        <span
                                            style={{
                                                padding: '4px 8px',
                                                borderRadius: '5px',
                                                fontSize: '12px',
                                                backgroundColor: page?.status ? '#d4f8dc' : '#ffd4d4',
                                                color: page?.status ? '#3da35d' : '#cc0000',
                                            }}
                                        >
                                            {page.status ? 'Active' : 'Inactive'}
                                        </span>
                                    </td>
                                    <td className="d-flex align-items-center justify-content-center">
                                        <span
                                            style={{ margin: '0 8px', cursor: page.isDefault ? 'not-allowed' : 'pointer', fontSize: '16px' }}
                                            title="Update details"
                                            onClick={() => !page.isDefault && handleUpdatePage(page)}
                                        >
                                            <i className="bi bi-pencil-square text-info"></i>
                                        </span>
                                        <span
                                            style={{ margin: '0 8px', cursor: 'pointer', fontSize: '16px' }}
                                            title="Edit Widgets"
                                            onClick={() => setUserPreferenceWidgets(page)}
                                        >
                                            <i className="bi bi-arrow-right-circle-fill text-info"></i>
                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {modalState.isOpen && (
                <div
                    className="modal fade modal-save-as show show-modal modal--opacity"
                    id="ammonia-inventory-form"
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                    tabIndex="-1"
                    aria-labelledby="staticBackdropLabel"
                    aria-hidden="true"
                    style={{ display: "block" }}
                >
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <div className="modal-title fnt14 fw-500" id="staticBackdropLabel">
                                    {modalState.type === 'new' ? 'Add New Page' : 'Update Page'}
                                </div>
                                <button
                                    type="button"
                                    className="btn-close px-1"
                                    data-bs-dismiss="modal"
                                    onClick={handleCloseModal}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <form>
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="form-floating mt-3">
                                                <input
                                                    type="text"
                                                    className="form-control floatingInput"
                                                    id="pageTitle"
                                                    name="pageTitle"
                                                    value={formData.pageTitle}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    placeholder=""
                                                />
                                                <label className="floatingInput-label" htmlFor="pageTitle">
                                                    Page Name
                                                </label>
                                                {errors.pageTitle && (
                                                    <div className="text-danger fnt10 fw-500">
                                                        Page Name is required
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-6 fnt14 mt-3">
                                            Default :
                                            <div className="form-check form-check-inline ms-3">
                                                <input className="form-check-input" type="radio" name="isDefault" value="true" checked={formData.isDefault === true} onChange={() => setFormData({ ...formData, isDefault: true })} />
                                                <label className="form-check-label">Yes</label>
                                            </div>
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" name="isDefault" value="false" checked={formData.isDefault === false} onChange={() => setFormData({ ...formData, isDefault: false })} />
                                                <label className="form-check-label">No</label>
                                            </div>
                                        </div>
                                        {modalState.type === 'update' && (
                                            <div className="col-6 fnt14 mt-3">
                                                Active :
                                                <div className="form-check form-check-inline ms-3">
                                                    <input className="form-check-input" type="radio" name="status" value="true" checked={formData.status === true}
                                                        onChange={() => setFormData({ ...formData, status: true })} />
                                                    <label className="form-check-label">Yes</label>
                                                </div>
                                                <div className="form-check form-check-inline">
                                                    <input className="form-check-input" type="radio" name="status" value="false" checked={formData.status === false}
                                                        onChange={() => setFormData({ ...formData, status: false })} />
                                                    <label className="form-check-label">No</label>
                                                </div>
                                                {errors.status && (
                                                    <div className="text-danger fnt10 fw-500">
                                                        Default screen can't be inactive
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={handleCloseModal} >
                                    Close
                                </button>
                                <button type="submit" className="btn btn-primary" data-bs-dismiss="modal" onClick={handleFormSave} >
                                    {modalState.type === 'new' ? 'Add Page' : 'Save Changes'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <SuccessPopup
                type={showSuccessPopup?.type}
                show={showSuccessPopup?.show}
                message={showSuccessPopup?.message}
                onClose={() => setShowSuccessPopup(false)}
            />
        </div>
    )
}
export default UserPreference;